import React from "react"
import {MoveTo_Manager} from "./model/manager"
import ModalMoveTo from "./components/modal"
import {ModalMoveTo_Type, MoveTo_CurrentStep} from "./@const"
import {EntityType} from "../../gd/const/item"
import ProjectSession from "../../model2/project/project-session"
import Task from "../../model2/task/task"
import Document from "../../model2/doc/document"
import Meeting from "../../model2/meeting/meeting"
import {ModalMove_Params, ModalMoveTask_Params} from "./@type"
import Modal_getMissingUsersTeams from "./actions/get-missing-users-and-teams"

function modalMove(manager: MoveTo_Manager, params?: ModalMove_Params) {
    gd.modal.showV5(
        <ModalMoveTo manager={manager} />,
        {
            toggleCallback: params?.toggleCallback,
        }
    )
}

export function modalMoveProject(project:ProjectSession, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.PROJECT)
    manager.projectsToMove      = [project]
    manager.originalProjectId   = project.treeParent?.id
    manager.targetProject       = project.treeParent
    manager.targetWorkspace     = project.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveTask(task:Task, params?: ModalMoveTask_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.id
    manager.targetProject       = params?.targetProject || task.project || undefined
    manager.targetWorkspace     = params?.targetProject?.workspace || task.project?.workspace || undefined

    manager.missingUsersTeams   = params?.missingUsersTeams
    manager.newSortPosition     = params?.sortPosition
    manager.onMoveCallback      = params?.callback

    if (params?.currentStep) {
        manager.currentStep         = params?.currentStep

        switch (manager.currentStep) {
            case MoveTo_CurrentStep.CHECKING_USERS:
                manager.validateUsers()
                break
        }
    }

    modalMove(manager, params)
}

// Popover-driven move: the target was picked in a popover, so move without a modal --
// unless users/teams are missing from the target, in which case fall back to the Move
// modal on its "add missing users" step (the pre-popover behaviour).
async function moveViaPopover(manager: MoveTo_Manager) {
    if (!manager.isTargetProjectAvailable) {
        return
    }

    const missingUsersTeams     = await Modal_getMissingUsersTeams(manager)
    const hasMissingUsersTeams  = !_.isEmpty(_.omitBy(missingUsersTeams, _.isEmpty))

    if (!hasMissingUsersTeams) {
        manager.commitMove()
        return
    }

    manager.missingUsersTeams   = missingUsersTeams
    manager.currentStep         = MoveTo_CurrentStep.ADD_MISSING_USERS

    modalMove(manager)
    return
}

export function moveTaskToProjectViaPopover(task:Task, targetProject:ProjectSession, callback?:callback) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.id
    manager.targetProject       = targetProject
    manager.targetWorkspace     = targetProject.workspace || undefined
    manager.onMoveCallback      = callback

    return moveViaPopover(manager)
}

// no targetProject = root of the "Projects" space (same as the modal's "Projects" root item)
export function moveProjectToProjectViaPopover(project:ProjectSession, targetProject?:ProjectSession, callback?:callback) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.PROJECT)
    manager.projectsToMove      = [project]
    manager.originalProjectId   = project.treeParent?.id
    manager.targetProject       = targetProject
    manager.targetWorkspace     = targetProject?.workspace || undefined
    manager.onMoveCallback      = callback

    return moveViaPopover(manager)
}

export function modalMoveTaskToTask(task:Task, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.TASK, EntityType.TASK)
    manager.tasksToMove         = [task]
    manager.originalProjectId   = task.project?.treeParent?.id
    manager.targetProject       = task.project?.treeParent || undefined
    manager.targetWorkspace     = task.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveDocument(document:Document, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.DOCUMENT)
    manager.documentToMove      = document
    manager.originalProjectId   = document.project?.treeParent?.id
    manager.targetProject       = document.project?.treeParent || undefined
    manager.targetWorkspace     = document.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveMeeting(meeting:Meeting, params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.MEETING)
    manager.meetingToMove       = meeting
    manager.originalProjectId   = meeting.project?.treeParent?.id
    manager.targetProject       = meeting.project?.treeParent || undefined
    manager.targetWorkspace     = meeting.project?.workspace || undefined

    modalMove(manager, params)
}

export function modalMoveMulti(projectsToMove: ProjectSession[], tasksToMove:Task[], params?: ModalMove_Params) {
    const manager = new MoveTo_Manager(ModalMoveTo_Type.MULTI)
    manager.projectsToMove  = projectsToMove
    manager.tasksToMove     = tasksToMove

    modalMove(manager, params)
}